/* eslint-disable prefer-promise-reject-errors */
import firebase from 'firebase';
import compose from 'recompose/compose';
import withStateHandlers from 'recompose/withStateHandlers';
import withHandlers from 'recompose/withHandlers';
import FileField from './file-field';
import withValue from '../with-value';
import {compressSaveAspectRatio} from '../../../../../../util/compressor';
import {readImageFromFile} from '../../../../../../util/image-utils';
import {POSTER_TYPE, getMimeType} from '../../../../common/types';

const STATUS_NULL = 'NULL';
const STATUS_PICKED = 'PICKED';
const STATUS_PENDING = 'PENDING';
const STATUS_SUCCESS = 'SUCCESS';
const STATUS_ERROR = 'ERROR';

const IMAGE_MAX_WIDTH = 448;
const imageCompression = image => compressSaveAspectRatio(image, IMAGE_MAX_WIDTH, 1);

const enhance = compose(
	withValue,
	withStateHandlers(
		{
			status: STATUS_NULL,
			progress: 0
		},
		{
			updateStatus: () => status => ({status}),
			updateProgress: () => progress => ({progress})
		}
	),
	withHandlers({
		handleDeleteFile: props => () => {
			const {
				name,
				setFieldValue,
				setFieldTouched
			} = props;

			setFieldValue(name, '');
			setFieldValue(`${name}Task`, undefined);
			setFieldTouched(name, true);
		},
		onDrop: props => (acceptedFiles, rejectedFiles) => {
			const {
				name,
				accept,
				setFieldValue,
				setFieldTouched,
				setFieldError,
				updateStatus,
				updateProgress,
				compression
			} = props;

			if (rejectedFiles.length > 0) {
				setFieldTouched(name, true);
				setTimeout(() => {
					setFieldError(name, props.acceptError);
				}, 10);
				return;
			}

			if (acceptedFiles.length <= 0) {
				return;
			}

			const file = acceptedFiles[0];
			const task = {
				file: file.name,
				isPending: true,
				name
			};

			const toUpload = compression && accept === getMimeType(POSTER_TYPE) ?
				readImageFromFile(file).then(imageCompression) :
				Promise.resolve(file);

			toUpload.then(data => {
				task.upload = (dirName = props.parentId) => {
					updateStatus(STATUS_PENDING);

					let hasCanceled = false;
					const refName = `${dirName}/${file.name}`;
					const uploadTask = firebase.storage()
						.ref(refName)
						.put(data);

					task.cancel = () => {
						hasCanceled = true;
						uploadTask.cancel();
					};

					uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
						snapshot => {
							if (!hasCanceled) {
								const {bytesTransferred, totalBytes} = snapshot;
								const progress = Math.round(100 * bytesTransferred / totalBytes);

								updateProgress(progress);
							}
						}
					);

					return uploadTask.then(value => {
						if (hasCanceled) {
							return Promise.reject({isCanceled: true});
						}

						file.isPending = false;
						updateStatus(STATUS_SUCCESS);
						setFieldTouched(name, true);
						return value;
					}).catch(error => {
						if (hasCanceled) {
							return Promise.reject({isCanceled: true});
						}

						file.isPending = false;
						updateStatus(STATUS_ERROR);
						setFieldTouched(name, true);
						setTimeout(() => {
							setFieldError(name, 'An error occurred during a file uploding.');
						}, 10);
						return Promise.reject(error);
					});
				};
			});

			updateStatus(STATUS_PICKED);
			setFieldValue(name, file.name);
			setFieldValue(`${name}Task`, task);
		}
	})
);

export default enhance(FileField);



// WEBPACK FOOTER //
// ./src/client/components/admin/common/form/file-field/index.js